<style lang="scss">
@screen mobile {
  .prices {
    &__form {
      @apply flex-wrap h-auto;
      >div {
        @apply w-full flex-none #{!important};
      }
      button {
        @apply px-2 w-full m-auto;
        &::after {
          content: ' Adicionar/atualizar'
        }
      }
    }
    &__display {
      &-field {
        @apply w-full;
      }
    }
    &__col {
      @apply m-0 w-full flex-wrap;
    }
    &__item {
      @apply inline-block;
    }
  }
}
</style>

<template>
  <article class="prices__section">
    <h3 class="section__subtitle">
      Planos de saúde
    </h3>

    <transition-group name="fade">
      <form
        :key="'health-insurance-form'"
        :disabled="sending"
        class="prices__form"
        id="health-insurance-form"
        @submit.prevent="saveDoctorHealthInsurance()"
      >
        <dr-field
          v-for="(field, name) in formData"
          :key="'field_healthInsurance_'+name"
          :id="name"
          :ref="name"
          :form.sync="formData"
          :field.sync="field"
          :value.sync="field.value"
          :validators.sync="$v.formData[name]"
          :class="field.classes"
          :edited-value.sync="field.editedValue"
          prefix="healthInsurance_"
        />

        <dr-submit
          :disabled="$v.$invalid"
          :sending="sending"
          class="prices__form-submit"
          text="+"
        />
      </form>

      <section
        v-if="loaded"
        :key="'health-insurance-list'"
      >
        <template v-if="healthInsuranceList.length > 0">
          <transition-group class="prices__list">
            <div
              v-for="item in healthInsuranceList"
              :key="`health-insurance-${item.id}`"
              class="prices__item"
            >
              <div class="prices__col prices__col--left prices__col--30">
                <div class="prices__name">
                  {{ item['health_insurance'].name }}
                </div>
              </div>

              <div class="prices__col prices__col--right prices__col--70 prices__col--sp-btwn">
                <div class="prices__display-field">
                  <div class="prices__display-field--title">
                    Registro ANS
                  </div>

                  <div class="prices__display-field--value">
                    {{ item['health_insurance']['ans_registration'] || '(não informado)' }}
                  </div>
                </div>

                <div class="prices__display-field">
                  <div class="prices__display-field--title">
                    Código na operadora
                  </div>

                  <div class="prices__display-field--value">
                    {{ item['operator_code'] }}
                  </div>
                </div>

                <div class="prices__display-field">
                  <div class="prices__display-field--title">
                    Preço da consulta
                  </div>

                  <div class="prices__display-field--value">
                    R$ {{ (item['value'] ? item['value'] : 0) | TO_BRL }}
                  </div>
                </div>

                <div class="prices__actions">
                  <button
                    class="prices__actions-btn prices__actions-btn--edit"
                    @click="editDoctorHealthInsurance(item.id)"
                  >
                    <dr-icon
                      color="#4a4a4a"
                      fill="#4a4a4a"
                      name="edit"
                    />
                  </button>

                  <button
                    class="prices__actions-btn prices__actions-btn--delete"
                    @click="confirmDeletion(item.id)"
                  >
                    <dr-icon
                      color="#F85359"
                      fill="#F85359"
                      name="excluiAlerta"
                    />
                  </button>
                </div>
              </div>
            </div>
          </transition-group>
        </template>

        <template v-else>
          <div class="prices__not-found">
            Você ainda não cadastrou planos de saúde.
          </div>
        </template>
      </section>

      <template v-else>
        <dr-loader
          key="health-insurance-loader"
          class="prices__loader"
          size="lg"
        />
      </template>
    </transition-group>
  </article>
</template>

<script>
import { formData, validations } from '@/data/formData/healthInsurance'
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import { mapGetters } from 'vuex'

export default {
  name: 'DrHealthInsurance',

  components: {
    drField,
    drSubmit
  },

  validations: {
    formData: validations
  },

  data () {
    return {
      formData,
      loaded: false,
      sending: false,
      healthInsuranceList: []
    }
  },

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    }),

    prefix () {
      return this.fn_IS_DOCTOR()
        ? '/doctor'
        : `/secretary/doctor/${this.$route.params.doctorId}`
    }
  },

  watch: {
    'formData.healthInsurance.value': {
      deep: true,
      immediate: false,
      handler (val) {
        if (val) {
          this.$set(this.formData.ansRegistration, 'value', val['ans_registration'])
        }
      }
    },

    office: {
      deep: true,
      immediate: false,
      handler () {
        this.init()
        this.resetForm()
      }
    }
  },

  created () {
    this.init()
  },

  mounted () {
    this.resetForm()
  },

  methods: {
    init () {
      this.fn_SHOW_PROGRESS()
      this.loaded = false
      this.getDoctorHealthInsurance()
        .then((res) => (this.healthInsuranceList = res.data.data))
        .catch((err) => {
          console.log('err \n', err)
          // this.handleError(err)
        })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.loaded = true
        })
    },

    async getDoctorHealthInsurance (insuranceId = null) {
      const id = insuranceId ? `/${insuranceId}` : ''
      const url = `${this.prefix}/doctor_office/${this.office.id}/doctor_office_health_insurance${id}`
      const res = await this.$http.get(url, this.$store.getters.getAuthHeader)
      return res
    },

    saveDoctorHealthInsurance () {
      const id = this.formData.id.value ? `/${this.formData.id.value}` : ''
      const url = `${this.prefix}/doctor_office/${this.office.id}/doctor_office_health_insurance${id}`
      const method = this.formData.id.value ? 'put' : 'post'
      const headers = this.$store.getters.getAuthHeader.headers
      const data = {
        'doctor_office_health_insurance': this.buildApiData()
      }
      this.formData.id.value && delete data['doctor_office_health_insurance'].healthInsurance

      this.fn_SHOW_PROGRESS()
      this.sending = true
      this.$http({ url, method, data, headers })
        .then((res) => {
          const msg = this.formData.id.value ? 'editado' : 'vinculado'

          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: `Plano de saúde ${msg} com sucesso.`,
            size: 'md',
            active: true
          })

          this.init()
        })
        .catch((err) => {
          // console.log('err \n', err)
          this.handleError(err)
        })
        .finally(() => {
          this.$set(this.formData['healthInsurance'], 'disabled', false)
          this.fn_HIDE_PROGRESS()
          this.resetForm()
          this.sending = false
        })
    },

    confirmDeletion (id) {
      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: 'Tem certeza que deseja apagar esse plano? Esta ação não poderá ser desfeita.',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose: (v) => {
          if (v) {
            this.deleteDoctorHealthInsurance(id)
          }
          this.$store.dispatch('setModalConfirm')
        },
        size: 'md',
        active: true
      })
    },

    deleteDoctorHealthInsurance (id) {
      const url = `${this.prefix}/doctor_office/${this.office.id}/doctor_office_health_insurance/${id}`

      this.fn_SHOW_PROGRESS()
      this.sending = true
      this.$http.delete(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: `Plano de saúde removido com sucesso.`,
            size: 'md',
            active: true
          })

          this.init()
        })
        .catch((err) => {
          // console.log('err \n', err)
          this.handleError(err)
        })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.resetForm()
          this.sending = false
        })
    },

    editDoctorHealthInsurance (id) {
      this.fn_SHOW_PROGRESS()
      this.getDoctorHealthInsurance(id)
        .then((res) => {
          const { data } = res

          this.resetForm()

          const autocompleteObj = {
            'ans_registration': data['health_insurance']['ans_registration'],
            id: data['health_insurance']['id'],
            name: data['health_insurance']['name'],
            value: data['health_insurance']['name']
          }

          const price = {
            raw: data['value'],
            converted: this.$options.filters.TO_BRL(data['value'])
          }

          this.$set(this.formData['id'], 'value', data['id'])
          this.$set(this.formData['healthInsurance'], 'value', autocompleteObj)
          this.$set(this.formData['healthInsurance'], 'editedValue', autocompleteObj)
          this.$set(this.formData['healthInsurance'], 'disabled', true)
          this.$set(this.formData['ansRegistration'], 'value', data['health_insurance']['ans_registration'])
          this.$set(this.formData['operatorCode'], 'value', data['operator_code'])
          this.$set(this.formData['value'], 'value', price)
          if (this.fn_IS_MOBILE()) {
            document.getElementById('health-insurance-form').scrollIntoView({ behavior: 'smooth' })
          }
        })
        .catch((err) => {
          // console.log('err \n', err)
          this.handleError(err)
        })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
        })
    },

    buildApiData () {
      return {
        healthInsurance: this.formData.healthInsurance.value.id,
        operatorCode: this.formData.operatorCode.value,
        value: this.formData.value.value.raw
      }
    },

    resetForm () {
      for (let field in this.formData) {
        if (this.formData[field].type === 'currency') {
          this.formData[field].value = { raw: 0, converted: null }
        } else {
          this.formData[field].value = null
          'editedValue' in this.formData[field] && (this.formData[field].updatedValue = null)
        }
      }

      for (let ref in this.$refs) {
        if (this.$refs[ref][0]) {
          if (this.$refs[ref][0].resetValues) {
            this.$refs[ref][0].resetValues()
          }
          if ('healthInsurance' in this.$refs[ref][0].$refs) {
            const autocomplete = this.$refs[ref][0].$refs['healthInsurance']
            autocomplete.resetValues()
          }
        }
      }

      this.$v.$reset()
    },

    handleError (err) {
      const msg = (typeof err !== 'object')
        ? err
        : ('errors' in err)
          ? this.findErrorMessage(err.errors)
          : 'Ocorreu um erro.'

      this.$store.dispatch('setModalAlert', {
        title: 'Erro',
        body: Array.isArray(msg) ? msg[0] : msg,
        size: 'md',
        active: true
      })
    },

    findErrorMessage (object) {
      let errorMessage = null
      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }
      if (Array.isArray(object)) {
        object.forEach((element) => recursiveSearch(element))
      } else {
        recursiveSearch(object)
      }
      return errorMessage
    }
  }
}
</script>
